/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsBillingInvoiceCtrl
 */
angular.module('mercury.modules.settings.support')
.controller('SupportInvitesCtrl', ["Company", "$scope", "$stateParams", "userinfo", "$state", function(Company, $scope, $stateParams, userinfo, $state) {
  console.log('entered SupportInvitesCtrl');
  $scope.okOnclick = function() {
    $scope.inviting = Company.inviteSupport($stateParams.id);
    $scope.inviting.then(function() {
      if ($scope.$close) {
        $scope.$close();
      } else {
        userinfo.companyDefaultReport().then(function(defaultReport) {
          $state.go(defaultReport);
        });
      }
    });
  };

  $scope.cancelClick = function() {
    if ($scope.$close) {
      $scope.$close();
    } else {
      userinfo.companyDefaultReport().then(function(defaultReport) {
        $state.go(defaultReport);
      });
    }
  };

  $scope.isManager = function() {
    var compId = $stateParams.id;
    if (compId === '' || compId === null) {
      compId = userinfo.activeCompany();
    }

    return userinfo.companyHasPermission('Manager', compId);
  };
}]);
